import { z } from "zod";

export const glAccountSchema = z.object({
  number: z.string()
    .min(1, "GL number is required.")
    .regex(/^\d{4}$/, "GL number must be exactly 4 digits (e.g. 6010)."),
  description: z.string()
    .min(1, "Description is required.")
    .max(200, "Description must be 200 characters or fewer."),
  accountType: z.enum(["Expense", "Income", "Asset", "Liability", "Bank", "CreditCard"]).default("Expense"),
});

export type GlAccountFormData = z.infer<typeof glAccountSchema>;
